import { render, staticRenderFns } from "./AccountChange.vue?vue&type=template&id=d936d248"
import script from "./AccountChange.vue?vue&type=script&lang=js"
export * from "./AccountChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports